import { combineReducers } from 'redux';
import feedbackResponse from './feedbackResponse';
import surveyConfig from './surveyConfig';
export default combineReducers({
  feedbackResponse,
  surveyConfig
});